import { resolveColorsPalette } from 'wix-rich-content-common';
import { DEFAULT_PALETTE } from '../defaults.js';

const resolveColors = (args) => {
  var _a, _b;
  const colors = [
    ...DEFAULT_PALETTE,
    ...args.colors ? Object.values(args.colors) : [],
    ...(_b = (_a = args.getColorFn) == null ? void 0 : _a.call(args)) != null ? _b : []
  ];
  return resolveColorsPalette({ colors, currentColor: args.currentColor });
};

export { resolveColors };
//# sourceMappingURL=resolve-colors.js.map
